import { PageHeader } from '../../ui/components';

interface PortalLink {
  name: string;
  blurb: string;
  url: string;
}

/**
 * Vite only exposes env vars prefixed VITE_ to client code, via
 * `import.meta.env`. This app's tsconfig only pulls in `@types/node`
 * (no `vite/client` ambient types), so `import.meta.env.X` would fail
 * `tsc --noEmit`; this helper sidesteps that with a local cast. Vite still
 * injects the real env object at runtime in both dev and the production
 * build regardless of the access pattern used to read it.
 */
function viteEnv(key: string): string | undefined {
  return (import.meta as unknown as { env?: Record<string, string | undefined> }).env?.[key];
}

const PORTALS: PortalLink[] = [
  {
    name: 'GovFin Finance Portal',
    blurb: 'Ministry budgets, supplier invoices, Central Bank payments',
    url: viteEnv('VITE_GOVFIN_URL') ?? 'http://localhost:4310',
  },
  {
    name: 'SPF Portal',
    blurb: 'Seychelles Pension Fund — contributions & benefits',
    url: viteEnv('VITE_SPF_URL') ?? 'http://localhost:4321',
  },
  {
    name: 'ASP Portal',
    blurb: 'Agency for Social Protection — welfare & benefits',
    url: viteEnv('VITE_ASP_URL') ?? 'http://localhost:4331',
  },
  {
    name: 'Sey-X Console',
    blurb: 'Cross-government data exchange gateway',
    url: viteEnv('VITE_SEYX_URL') ?? 'http://localhost:4351',
  },
  {
    name: 'ServiceDesk Console',
    blurb: 'Citizen appointments & front-counter service',
    url: viteEnv('VITE_SERVICEDESK_URL') ?? 'http://localhost:4361',
  },
  {
    name: 'OpenGov Portal',
    blurb: 'FOI requests, referrals, public participation',
    url: viteEnv('VITE_OPENGOV_URL') ?? 'http://localhost:4371',
  },
  {
    name: 'Analytics Portal',
    blurb: 'Cross-government reporting & dashboards',
    url: viteEnv('VITE_ANALYTICS_URL') ?? 'http://localhost:4381',
  },
];

export function Launcher() {
  return (
    <div>
      <PageHeader title="Module launcher" subtitle="Jump to every other live One Gov portal" />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {PORTALS.map((p) => (
          <a
            key={p.name}
            href={p.url}
            target="_blank"
            rel="noreferrer"
            className="card block p-4 transition hover:border-brand-500 hover:shadow-md"
          >
            <div className="text-sm font-bold text-slate-900">{p.name}</div>
            <p className="mt-1 text-xs text-slate-500">{p.blurb}</p>
            <div className="mt-3 text-[11px] font-semibold text-brand-600">{p.url} →</div>
          </a>
        ))}
      </div>
    </div>
  );
}
